import Connect from './Connect';
import Contact from './Contact';
import Features from './Features';
import Footer from './Footer';
import Header from './Header';
import Intro from './Intro';
import Sidebar from './Sidebar';
import Spotlights from './Spotlights';
import Layout from './Layout';

export {
    Connect,
    Contact,
    Features,
    Footer,
    Header,
    Intro,
    Sidebar,
    Spotlights,
    Layout,
};

export default {
    Connect,
    Contact,
    Features,
    Footer,
    Header,
    Intro,
    Sidebar,
    Spotlights,
    Layout,
};
